//https://dribbble.com/shots/3400947-Documents-screen

import styles from '../styles/pages/EncryptedString.module.scss';
import logo from "../assets/logo/boxlogo.svg";

import React, { HTMLInputTypeAttribute, useEffect, useRef, useState } from 'react'
import { useSearchParams } from "react-router-dom";
import { Input } from '../components/ui/input';

import warning from '../assets/images/warning.svg';
import empty from '../assets/images/empty.svg'

import { Search, FileText, ArrowDownToLine, Info, Check, X, ArrowDownUp, LayoutGrid, AlignJustify, Table as TableIcon, Eye, MessageCircle, ThumbsUp, ThumbsDown, Printer, Calendar, Mail, File, Loader2, Plus, Minus, Trash2, Forward as ForwardIcon } from 'lucide-react';
import { YYYYMMDDtoDate } from '../functions/format';
import { format } from 'date-fns';
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from '../components/ui/tooltip';
import axios from "src/axios/axios";

import { Document, Page, pdfjs } from 'react-pdf'
import "react-pdf/dist/esm/Page/TextLayer.css";
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { downloadFile } from "../functions/actions/documents";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "../components/ui/sheet";
import { filterObjectsByValue } from "../functions/general/filter";
import { useInfiniteQuery, useQuery } from "react-query";

import { useIntersection } from '@mantine/hooks'
import { Table, TableBody, TableCell, TableHeader, TableRow, TableHead } from '../components/ui/table';
import { Checkbox } from '../components/ui/checkbox';
import { searchMetavalue } from '../functions/actions/metadata';
import { isInterface } from '../functions/general/checks';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import Preview from '../components/files/Preview';
import toast, { Toaster } from 'react-hot-toast';
import { AlertDialog, AlertDialogAction, AlertDialogTrigger, AlertDialogContent, AlertDialogCancel } from '../components/ui/alert-dialog';
import { RecipientsInput } from '../components/files/SendMail';
import { setNotification } from '../redux/actions';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../hooks/redux';
import { RootState } from '../store';
import TooltipForce from '../components/ui/tooltip-force';

import docResult from "./result.json"
import verificationSettings from "./verificationsettings.json"
import metatypesResult from "./metatypes.json"
import Approve from '../components/workflow/Approve';
import Reject from '../components/workflow/Reject';
import Forward from '../components/workflow/Forward';
import { useTranslation } from 'react-i18next';
import { getWindevLang } from 'src/lib/lang';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;


export type Doc = {
    docid: number;
    doctype: string;
    file: string;
    filename: string;
}

export const InfoSheet = ({document, metatypes, token}:{document:Document, metatypes:Metatype[], token?:string}) => {
    const { i18n } = useTranslation()

    const { data:doctypes } = useQuery<DoctypeObject[] | null>({
        queryKey: [`doctypes`],
        queryFn: async () => {
            try {
                const { data } = await axios.get(`doctypes/list`)
                if(data.errorcode!==0){throw new Error(data.message)}
                return data.object
            } catch (error) {
                return null
            }
        },
        enabled: !!token,
        refetchOnWindowFocus: false
    })

    return (
        <Sheet>
            <SheetTrigger asChild><button className='flex items-center justify-center w-10 h-10 bg-white rounded-full hover:bg-slate-200'><Info className='w-5 text-slate-500'/></button></SheetTrigger>
            <SheetContent position='right' size='lg'>
                <SheetHeader>
                    <SheetTitle>{document.filename}</SheetTitle>
                    <SheetDescription>{format(YYYYMMDDtoDate(document.docdate), 'd MMM yyyy')} - {doctypes ? doctypes.find(i=>i.doctype===document.doctype)?.docoms.find(i=>i.nationid===getWindevLang(i18n.language))?.oms : document.doctype}</SheetDescription>
                    <div className="flex flex-col">
                    {document.metadata.map((md, id)=>(
                        <div className="flex items-center gap-4 py-2 border-t" key={`${md.metatype}_${id}`}>
                            <p className="font-semibold">{metatypes.find(item => item.metatype === md.metatype)?.metatype_oms.find(item => item.nationid === getWindevLang(i18n.language))?.oms}</p>
                            <p>{md.metavalue}</p>
                        </div>
                    ))}
                    </div>
                </SheetHeader>
            </SheetContent>
        </Sheet>
    )
}

export const MailPopup = ({document, result}:{document:Doc, result:Result}) => {
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch();

    const [recipients, setrecipients] = useState<string[]>();
    const [subject, setsubject] = useState<string>('');
    const [message, setmessage] = useState<string>('');

    const [is_enabled, setis_enabled] = useState<string | boolean>(false);

    useEffect(()=>{
        checkMailSettings()
    }, [])

    const checkMailSettings = async () => {
        try {
            console.log(result)
            const {data} = await axios.get(`email/checksettings?token=${result.token}`);
            if(data.errorcode === 0){ setis_enabled(true) }
            else { setis_enabled('Geen e-mailprofiel geconfigureerd') }
        } catch (error) {
            
        }
    }

    const [is_sending, setis_sending] = useState(false);
    async function send() {
        const obj = {
            token: result.token || 'TOKEN',
            body: message,
            subject:subject,
            attachments: [
                {
                    file: document?.file,
                    filename: document?.filename || 'Document'
                }
            ],
            recipients: recipients,
            bodyformat: 'HTML',
            sender:''
        }
        
        console.log(obj)

        try {
            setis_sending(true)
            toast.loading(`${t('Mail versturen')}...`, {id:'sendMail'})
            let {data} = await axios.post(`email/send`, obj)
            if(data.errorcode === 0){
                //Success
                setmessage('');
                setsubject('')
                setrecipients(undefined)
                dispatch(setNotification({type:'success', title:'Succes', message:t('Mail verstuurd')}))
                toast.success(t('Mail verstuurd'), {id:'sendMail'})
            }
            else {
                //Something went wrong
                console.log(obj)
                console.log(data)
                //dispatch(setNotification({type:'error', title:'Error', message:'Mail versturen mislukt'}))
                toast.error(t('Mail versturen mislukt'), {id:'sendMail'})
            }
            
        } catch (error) {
            console.log(error)
            toast.error(t('Mail versturen mislukt'), {id:'sendMail'})
            //dispatch(setNotification({type:'error', title:'Error', message:'Mail versturen mislukt'}))
        } finally {
            setis_sending(false)
        }
    }

    return (
        <>
        <Toaster />
        <AlertDialog>
            <AlertDialogTrigger asChild>
                <div>
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger asChild><button disabled={typeof(is_enabled) === 'string'} className='flex items-center justify-center w-10 h-10 bg-white rounded-full hover:bg-slate-200 disabled:opacity-50'><Mail className='w-5 text-slate-500'/></button></TooltipTrigger>
                            <TooltipContent><p className='whitespace-nowrap'>{is_enabled === true ? t('Als bijlage versturen') : is_enabled.toString()}</p></TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
            </AlertDialogTrigger>
            <AlertDialogContent className='max-h-[90vh] overflow-auto p-0'>

            <div className='p-4'>
                <div className='flex items-center justify-between gap-1'>
                    <p className='font-medium'>{t('Nieuw bericht')}</p>
                    <div className='flex gap-1'>
                    <AlertDialogCancel>{t('Sluiten')}</AlertDialogCancel>
                    </div>
                </div>
                <div className='py-4 border-b'>
                    <RecipientsInput onAddRecepient={(list)=>{ setrecipients(list) }}/>
                </div>
                <div className='flex items-center py-4 border-b'>
                    <input value={subject} onChange={({currentTarget})=>{ setsubject(currentTarget.value) }} maxLength={80} className='w-full focus:outline-none' placeholder='Onderwerp...'/>
                    <div className='px-1 text-sm rounded-sm bg-neutral-200 text-neutral-500'>{80 - (subject?.length || 0)}</div>
                </div>
                <div className='mt-4'>
                    <textarea value={message} onChange={({currentTarget})=>{ setmessage(currentTarget.value )}} className='w-full resize-none h-52 focus:outline-none' placeholder='Uw bericht...'/>
                    <div className='flex items-center gap-2'>
                        <div className='rounded-sm border flex justify-center items-center w-8 h-8 min-w-[2rem]'><File className='w-4 text-neutral-400'/></div>
                        <p className='font-semibold truncate'>{document.filename}</p>
                    </div>
                </div>
            </div>

            <div className='flex justify-end p-4 rounded-b-lg bg-slate-100'>
                <Button disabled={is_sending} onClick={()=>{ send() }}>{is_sending ? <Loader2 className='animate-spin'/> : 'Versturen'}</Button>
            </div>

                
            </AlertDialogContent>
        </AlertDialog>
        </>
    )
}


type View = 'list' | 'grid' | 'table'

const EncryptedString = () => {
    const PreviewDocument = () => {
        return (
            <div className='fixed top-0 left-0 z-20 flex flex-col items-center w-screen h-screen py-8 overflow-auto bg-white/80 backdrop-blur-sm'>
                <div className='flex items-center justify-between w-full px-8 mb-4'>
                    <button onClick={()=>{ setopened_document(null) }} className='text-sm font-semibold underline uppercase'>Sluiten</button>
                    <p className='text-lg font-medium'>{opened_document && opened_document.filename}</p>
    
                    {(metatypes && opened_document) && 
                    <div className='flex items-center bg-white border rounded-full'>
                        <InfoSheet document={opened_document} metatypes={metatypes}/>                       
                        {/* <button onClick={()=>handleDownloadFile(_posts?.find(item => item.docid === opened_document.docid))} className='flex items-center justify-center w-10 h-10 bg-white rounded-full hover:bg-slate-200'><ArrowDownToLine className='w-5 text-slate-500'/></button> */}
                    </div>
                    }
                </div>
                {opened_document && 
                <>
                {opened_document.options.wf === 1 &&
                <div className='sticky top-0 z-10 flex items-center gap-2 p-1 mb-4 bg-white border border-solid rounded-full'>
                    <TooltipProvider delayDuration={0}>
                        <Tooltip>
                            <TooltipTrigger asChild><button onClick={()=>{setselected_validating_documents([opened_document])}} className='flex items-center justify-center w-10 h-10 rounded-full hover:bg-emerald-100'><Check className='w-5 text-emerald-500'/></button></TooltipTrigger>
                            <TooltipContent>Document goedkeuren</TooltipContent>
                        </Tooltip>
    
                        <Tooltip>
                            <TooltipTrigger asChild><button onClick={()=>{setselected_rejecting_documents([opened_document])}} className='flex items-center justify-center w-10 h-10 rounded-full hover:bg-red-100'><X className='w-5 text-red-500'/></button></TooltipTrigger>
                            <TooltipContent>Document afkeuren</TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                </div>
                }
                
                {result && <Preview docid={opened_document.docid} filename={opened_document.filename} />}
                
                </>
                }
            </div>
        )
    }

    const [searchParams, setSearchParams] = useSearchParams()
    const main_result = useRef<Result>()

    const [selected_view, setselected_view] = useState<View>('list');

    const [ascending_order, setascending_order] = useState(false);
    const [result_state, setresult_state] = useState<'error' | 'loading' | 'loaded'>('loading');
    
    const [result, setresult] = useState<Result | null>();

    const [selected_document, setselected_document] = useState<Doc | null>();

    const [selected_index, setselected_index] = useState<number>(0);

    const [metatypes, setmetatypes] = useState<Metatype[]>();

    const [selected_validating_documents, setselected_validating_documents] = useState<Document[] | null>(null)
    const [selected_rejecting_documents, setselected_rejecting_documents] = useState<Document[] | null>(null);
    const [selected_comment_document, setselected_comment_document] = useState<Document | null>(null);

    const getDocument = async (encrypted_string:string) => {
        try {
            setresult_state('loading')
            const {data} = await axios.get(`documents/link/s?encrypted_string=${encrypted_string}`)
            // LECOT
            //let data = docResult
            if(data.errorcode === 0){ 
                main_result.current = data.object as Result;
                setresult(data.object as Result)
                setresult_state('loaded')
                if(!selected_index){ setselected_index(0) }
                
                getMetatypes()
            }
            else {
                setresult_state('error')
            }
        } catch (error) {
            console.log(error)
            setresult_state('error')
        }    
    }

    const getMetatypes = async () => {
        try {
            const {data} = await axios.get(`metatypes/list/`)
            // LECOT
            //const data = metatypesResult
            if(data.errorcode === 0){
                setmetatypes(data.object as Metatype[])
            }
            else {
                console.log(data)
            }
            
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{    
        console.log("Selected file index: ", selected_index)
        if(result && result.documents){   
            let index = selected_index;
            if(!result.documents[index]){ index = 0 }
            const doc = result?.documents[index];
            if(doc){
                loadDocument(doc)
            }
        } 
    }, [selected_index, result])

    useEffect(()=>{
        let encrypted_string = searchParams.get('es') || '';
        getDocument(encrypted_string);
    }, [])

    async function loadDocument(document:Document) {
        const { data } = await axios.get(`documents/get?docid=${document.docid}&token=${result?.token}`)
        if(data.errorcode === 0){
            setselected_document(data.object);
        }
        else {
            console.log(data);
        }
    }

    const handleDownloadFile = (document:Doc) => {
        downloadFile(document?.file, document.filename || 'FITdoc Document');
    }

    const handleSearchDocument = (value:string) => {
        const val = value || '';
        if(main_result.current?.documents){
            const filter = filterObjectsByValue(main_result.current.documents, val) as Document[]
            setselected_index(0)
            setresult(prev => {
                if(prev) { return {...prev, documents:filter} }
                else { return null }
            })
        }
    }

    const handleSortResult = () => {
        if(result?.documents){
            let order = ascending_order;
            setascending_order(prev =>{ order = !prev; return !prev });

            const sort = result.documents.sort((a, b) => {
                const dateA = new Date(`${a.docdate.slice(0, 4)}-${a.docdate.slice(4, 6)}-${a.docdate.slice(6, 8)}`);
                const dateB = new Date(`${b.docdate.slice(0, 4)}-${b.docdate.slice(4, 6)}-${b.docdate.slice(6, 8)}`);

                if (order) {
                    return dateA.getTime() - dateB.getTime();
                } else {
                    return dateB.getTime() - dateA.getTime();
                }

            });

            setresult(prev => {
                if(prev) { return {...prev, documents:sort} }
                else { return null }
            })
        }
    }

    //============================================

        // GRID CODE 
        const [opened_document, setopened_document] = useState<Document | null>();

        const fetchDoc = async (docid: number) => {
            const { data } = await axios.get(`documents/get?docid=${docid}&token=${result?.token}`)
            if(data.errorcode === 0){
                return data.object
            }
            else {
                return null;
            }
        }

        // const { data, fetchNextPage, isFetchingNextPage } = useInfiniteQuery(
        //     ['documents'],
        //     async ({ pageParam = 0 }) => {
        //         const docid = result?.documents[pageParam]?.docid || 0
        //         const rs = await fetchDoc(docid)
        //         return rs;
        //     },
        //     {
        //         getNextPageParam: (_, pages) => {
        //             return pages.length
        //         },
        //         initialData: result?.documents[0] ? {
        //             pages: [],
        //             pageParams: [0]
        //         } : undefined,
        //         enabled: !!(result?.documents && result.documents.length > 0),
        //         refetchOnWindowFocus: false
        //     },
            
        // )

        const gridRef = useRef<HTMLDivElement>(null)
        const { ref, entry } = useIntersection({
            root: gridRef.current,
            threshold: 1
        })

        // useEffect(()=>{
        //     if(entry?.isIntersecting && !opened_document) fetchNextPage()
        // }, [entry, opened_document])

       // const _posts = data?.pages.flatMap((page) => page)

    //============================================

        // TABLE CODE
        const [selected_rows, setselected_rows] = useState<Document[]>();
        const [view_all, setview_all] = useState(false);

    //============================================
    
    const [verificationsettings, setverificationsettings] = useState<VerificationSetting[] | null>(null);
    
    useEffect(()=>{

        if(selected_validating_documents){ setisopen_approve(true) }
        if(selected_rejecting_documents){ setisopen_reject(true) }

        if(selected_validating_documents || selected_rejecting_documents){
            const getVS = async () => {
                try {
                    toast.loading('Workflow settings ophalen...', {id:'vs'})
                    const actionId = selected_rejecting_documents ? (selected_rejecting_documents[0]?.wf.wfdef_actionid) : (selected_validating_documents ? selected_validating_documents[0]?.wf.wfdef_actionid : 0)
                    const {data} = await axios.get(`wf/verificationsettings?token=${result?.token}&wfdef_actionid=${actionId}`)
                    // LECOT
                    //const data = verificationSettings
                    if(data.errorcode!==0){throw new Error(data.message)}
                    setverificationsettings(data.object.metadata)
                } catch (error) {
                    console.log(error)
                    toast.error('Error workflow', {id:'vs'})
                } finally {
                    toast.remove('vs')
                }
            }
            getVS()
        } else { setverificationsettings(null) }
    }, [selected_validating_documents, selected_rejecting_documents])

    const [isopen_approve, setisopen_approve] = useState(false);
    const [isopen_reject, setisopen_reject] = useState(false);
    const [isopen_forward, setisopen_forward] = useState(false);

    function resetPage() {
        setselected_document(null);
        setselected_rejecting_documents(null); setselected_validating_documents(null);
        setverificationsettings(null)
        setisopen_approve(false); setisopen_reject(false); setisopen_forward(false);
        getDocument(searchParams.get('es') || '')
    }

    // function handleResetAndNext() {
    //     const lengthDocs = result?.documents.length || 0;
    //     if(selected_index && (selected_index < lengthDocs)){
    //         const curr = selected_index
    //         setselected_index(curr+1); 
    //     }
    //     resetPage()
    // }


    return (
        <>
        <Toaster />
        <div className='h-full'>

            <Approve onSuccess={()=>{ resetPage() }} document={selected_validating_documents ? selected_validating_documents[0] : null} metatypes={metatypes} settings={verificationsettings} open={isopen_approve} onOpenChange={(o)=>{setselected_validating_documents(null); setisopen_approve(o)}}/>
            <Reject onSuccess={()=>{ resetPage() }} document={selected_rejecting_documents ? selected_rejecting_documents[0] : null} metatypes={metatypes} settings={verificationsettings} open={isopen_reject} onOpenChange={(o)=>{setselected_rejecting_documents(null); setisopen_reject(o)}}/>
            {(typeof(selected_index) === 'number' && result && Array.isArray(result.documents)) ? <Forward onSuccess={()=>{ resetPage() }} docid={result?.documents[selected_index].docid} open={isopen_forward} onOpenChange={(o)=>{setisopen_forward(o)}}/> : ''}

            {selected_comment_document &&
            <div className='z-[21] h-full w-screen fixed top-0 left-0 bg-background/80 backdrop-blur-sm flex justify-center items-center'>
                <div className="flex flex-col w-full max-w-lg gap-4 p-6 scale-100 border shadow-lg opacity-100 bg-background animate-in fade-in-90 slide-in-from-bottom-10 sm:rounded-lg sm:zoom-in-90 sm:slide-in-from-bottom-0 md:w-full">
                    <button onClick={()=>{setselected_comment_document(null)}} className='absolute flex items-center justify-center w-6 h-6 duration-100 rounded-sm opacity-50 right-1 top-2 hover:opacity-100 hover:bg-slate-100'><X className='w-4' strokeWidth={1.5}/></button>
                    
                    <h2 className='text-xl font-semibold'>Opmerking op document</h2>

                    <div>
                        <Label>Opmerking</Label>
                        <Textarea className='resize-none'/>
                    </div>

                    <div className='flex justify-end'>
                        <Button onClick={()=>{setselected_comment_document(null)}} variant='ghost'>Annuleren</Button>
                        <Button>Opslaan</Button>
                    </div>
                </div>
            </div>
            }

            {/* Header */}
            <div className='flex items-center justify-between h-20 gap-4 px-8 py-4 bg-white border-b shadow-lg'>
                <div className="flex items-center gap-5">
                    <img src={logo} alt="Fitdoc Logo" className="h-10"/>
                    <Input onChange={({currentTarget})=>{ handleSearchDocument(currentTarget.value) }} placeholder='Document zoeken...' startEnhancer={<Search className='w-4 opacity-50'/>} className='w-fit'/>

                    <div className="items-center hidden h-10 px-1 border rounded-full sm:flex">
                        <button onClick={()=>{ setselected_view('list') }} className={`${selected_view === 'list' ? 'bg-slate-200' : 'bg-white opacity-50'} w-8 h-8 min-w-[32px] flex justify-center items-center rounded-full hover:bg-slate-100`}><AlignJustify className="w-5 text-neutral-500"/></button>
                        <button onClick={()=>{ setselected_view('grid') }} className={`${selected_view === 'grid' ? 'bg-slate-200' : 'bg-white opacity-50'} w-8 h-8 min-w-[32px] flex justify-center items-center rounded-full hover:bg-slate-100`}><LayoutGrid className="w-5 text-neutral-500"/></button>
                        {/* <button onClick={()=>{ setselected_view('table') }} className={`${selected_view === 'table' ? 'bg-slate-200' : 'bg-white opacity-50'} w-8 h-8 min-w-[32px] flex justify-center items-center rounded-full hover:bg-slate-100`}><TableIcon strokeWidth={1.5} className="w-5 text-neutral-500"/></button> */}
                    </div>
                </div>
                
                <div className='items-center hidden gap-2 sm:flex'>
                    <div className='flex items-center justify-center w-10 h-10 font-bold rounded-full select-none bg-slate-200 text-slate-500'>{result?.user.name.charAt(0)}</div>
                    <p className='font-semibold whitespace-nowrap'>{result?.user.name} {result?.user.lastname}</p>
                </div>
            </div>

            {result_state === 'loading' &&
            <div className='h-[calc(100vh-5rem)] flex justify-center items-center flex-col gap-4'>
                <p className='text-xl font-semibold'>Even geduld...</p>
                <img className='w-40' src={empty} alt="Loading" />
            </div>
            }
            {result_state === 'error' &&
            <div className='h-[calc(100vh-5rem)] flex justify-center items-center flex-col gap-4'>
                <p className='text-xl font-semibold'>Ai! Er liep iets mis</p>
                <img className='w-32' src={warning} alt="Loading" />
            </div>
            }

            {(result && selected_view === 'list') && 
            <div className='grid grid-cols-1 md:grid-cols-3'>
                <div className='bg-slate-100 h-40 md:h-[calc(100vh-5rem)] overflow-y-auto overflow-x-hidden'>

                    <div className="items-center hidden gap-2 p-4 m-4 bg-white border rounded-lg md:flex">
                        <button onClick={()=>{ handleSortResult() }} className='flex items-center justify-center w-10 h-10 bg-white border border-solid rounded-full border-neutral-200 hover:bg-slate-100 hover:border-slate-200'><ArrowDownUp className="w-5 text-neutral-500"/></button>
                        {result?.documents && <p className="hidden font-medium md:flex whitespace-nowrap">Aantal: <span className="ml-1 font-semibold">{result?.documents.length} documenten</span></p>}
                    </div>


                    {Array.isArray(result.documents) && result?.documents.map((document, index) => (
                    <div onClick={()=>{ setselected_index(index) }} className={`${selected_index === index && 'bg-slate-50 shadow-sm'} cursor-pointer relative flex gap-2 items-center py-4 px-8 duration-200 hover:bg-slate-50`} key={`${document.docid}_${index}`}>
                        <div className='w-10 h-10 min-w-[2.5rem] flex justify-center items-center'><FileText strokeWidth={1} className='opacity-80'/></div>
                        <div>
                            {document.metadata.map((md, ind)=>{
                                let show = metatypes ? metatypes.find(i=>i.metatype===md.metatype)?.columndisplay : false
                                const label = metatypes ? metatypes.find(i=>i.metatype===md.metatype)?.metatype_oms.find(i=>i.nationid===12)?.oms || md.metatype : md.metatype
                                if(md.metatype === 'AKFBRUT' || md.metatype === 'FACTNRA'){ show = true }
                                if(!show) return (<React.Fragment key={ind}></React.Fragment>)
                                return (
                                    <p key={`${ind}_${md.metatype}`}><span className='font-semibold'>{label}</span>: {md.metavalue}</p>
                                )
                            })}
                            <p className='text-sm opacity-60'>{format(YYYYMMDDtoDate(document.docdate), "d MMMM yyyy")}</p>
                        </div>

                        {selected_index === index &&
                        <div className='absolute right-0 w-1 h-full bg-slate-600'></div>
                        }
                    </div>
                    ))}
                    
                </div>
                <div className='h-[calc(100vh-5rem)] overflow-y-auto col-span-2 p-8 flex flex-col gap-8 relative'>
                    <div className='sticky top-0 z-10 flex items-center justify-between'>
                        {(selected_index !== null && Array.isArray(result.documents) && result.documents[selected_index] && result.documents[selected_index].options.wf === 1) && 
                        <div className='flex items-center gap-2 p-1 bg-white border border-solid rounded-full'>
                        </div>
                        }
                        {(selected_index !== null && metatypes && selected_document && Array.isArray(result.documents) && result.documents[selected_index]) && 
                        <div className='flex items-center bg-white rounded-full'>
                            <InfoSheet document={result?.documents[selected_index]} metatypes={metatypes}/>    
                            <MailPopup document={selected_document} result={result}/>                 
                            <button onClick={()=>handleDownloadFile(selected_document)} className='flex items-center justify-center w-10 h-10 bg-white rounded-full hover:bg-slate-200'><ArrowDownToLine className='w-5 text-slate-500'/></button>
                        </div>     
                        }
                    </div>

                    <div className='h-full'>
                        <div className='max-h-[100vh-300px] p-4 overflow-auto flex flex-col items-center'>
                            {isInterface(selected_document, {} as Doc) ? <Preview docid={selected_document.docid} filename={selected_document.filename} /> : (result_state === 'error' && <p>Geen preview</p>)}
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
        </>
    )
}

// Documents > Wf > wfdef_actionid
// wfdef_actionid > wf/verificationsettings (token, wfdef_actionid)
// {metatype, multiple, required}[] > metatype GET (int, text, date...?) 


export default EncryptedString

export interface VerificationSetting {
    metatype: string;
    multiple: boolean;
    required: boolean
}

export interface Result {
    token:     string;
    user:      ResultUser;
    documents?: Document[];
}

export interface ResultUser {
    companyname: string;
    name:        string;
    lastname:    string;
}

export interface Document {
    docid:    number;
    docdate:  string;
    version:  number;
    doctype:  string;
    user:     string;
    filename: string;
    metadata: Metadata[];
    remarks:  any[];
    options:  Options;
    wf:       Wf;
}

export interface Metadata {
    metatype:  string;
    metavalue: string;
    required?: boolean;
}

export interface Options {
    wf:       number;
    favorite: number;
}

export interface Wf {
    users: UserElement[];
    wfdef_actionid?: number;
    actiontype?: string
}

export interface UserElement {
    username: string;
    remark:   string;
    result:   string;
}

export interface Metatype {
    metatype:          string;
    required:          number;
    metatype_oms:      MetatypeOm[];
    showincompactview: number;
    datatype:          string;
    displaytype:       string;
    columndisplay:     boolean;
}

export interface MetatypeOm {
    nationid: number;
    oms:      string;
}
